import { Inject } from '@odinjs/odin';
import Controller, { OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';

import BaseController from '../../BaseController';
import { PainScaleAPI } from '@philips-emr/health-professional-components/src/components';
import { FragmentNames } from '../../../codegen';
import { LightFacesPainScaleAliases } from '../../../codegen/constants/aliases/light-faces-pain-scale-aliases';

interface ContextDataProps {
  data: {
    setPainScaleValue: (value: number) => void;
  }
}

@Controller({ fragment: FragmentNames.LIGHT_FACES_PAIN_SCALE })
class LightFacesController extends BaseController {

  @Inject(LightFacesPainScaleAliases.PAIN_SCALE_LIGHT_FACES)
    painScaleApi!: PainScaleAPI;

  @OnUnmount({target: LightFacesPainScaleAliases.PAIN_SCALE_LIGHT_FACES})
  onLayoutUnmount(): void {
    if(this.painScaleApi.getValue()) {
      const { data:  { setPainScaleValue }} = this.context as unknown as ContextDataProps;
      setPainScaleValue(Number(this.painScaleApi.getValue()));
    }
  }
}
export default LightFacesController;
